import { atom } from "recoil";

export const AlertState = atom({
  key: "AlertState",
  default: { alert: false, message: null, type: null },
});
